import { connect } from 'react-redux'
import Actions from './actions'
import { isSibarOpen } from '../../../../../../stores/discussion/discussion.selectors'
import {
  openSidebar,
  closeSidebar
} from '../../../../../../stores/discussion/discussion.actions'

const mapStateToProps = state => ({
  sidebarOpen: isSibarOpen(state)
})

const mapDispatchToProps = dispatch => ({
  onOpenSidebar: () => dispatch(openSidebar()),
  onCloseSidebar: () => dispatch(closeSidebar())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Actions)
